import React, { useState, useEffect } from "react";
import Header from "./Header";
import FooterNav from "./FooterNav";
import Footer from "./Footer";
import { N_addToken, N_updateToken } from "../redux/helpers/api_functions_new";
import { useSelector } from "react-redux";

export default function AddToken(props) {
  const [username, setUsername] = useState(null);
  const [symbol, setSymbol] = useState(null);
  const [supply, setSupply] = useState(null);
  const [prec, setPrec] = useState(null);
  const [chain, setChain] = useState("  ");
  const [tokenAddr, SetTokenAddr] = useState(null);
  const [price, setPrice] = useState(null);
  const [isVisible, setIsVisible] = useState(false);
  const [filedata, setFileData] = useState();
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [successMessageUpd, setSuccessMessageUpd] = useState("");
  const [errorMessageUpd, setErrorMessageUpd] = useState("");
  const [fPrice, setfPrice] = useState(null);
  const [contractAddr, setContractAddr] = useState(null);
  const [createdAt, setCreatedAt] = useState(null);
  const [status, setStatus] = useState(null);
  const [contractType, setContractType] = useState(null);
  const [fUsername, setFUsername] = useState(null);
  const [fSymbol, setFSymbol] = useState(null);
  const [fSupply, setFSupply] = useState(null);
  const [fPrec, setFPrec] = useState(null);
  const { user } = useSelector((state) => state.AuthReducer);
  const token = user?.params ? user.params.token : user.token;

  const uploadIMG = (input) => {
    if (input.target.files && input.target.files[0]) {
      setFileData(input.target.files[0]);
    }
  };
  const handleAddToken = () => {
    if (chain && tokenAddr) {
      N_addToken(chain, tokenAddr).then((res) => {
        if (res?.status === 200) {
          setIsVisible(true);
          setUsername(res?.name);
          setSupply(res?.totalSupply);
          setPrec(res?.decimals);
          setSymbol(res?.symbol);
          setSuccessMessage(res?.message);
          setErrorMessage("");
        } else {
          setIsVisible(false);
          setErrorMessage(res?.error);
          setSuccessMessage("");
        }
      });
    } else {
    }
  };

  const handleUpdateTkn = () => {
    N_updateToken(chain, tokenAddr, price, filedata, token).then((res) => {
      if (res?.status === 200) {
        setSuccessMessageUpd(res?.message);
        setErrorMessageUpd("");
      } else {
        setErrorMessageUpd(res?.message ? res?.message : res?.error);
        setSuccessMessageUpd("");
      }
    });
  };

  useEffect(() => {
    if (token) {
      N_addToken("", "", token, "get").then((res) => {
        if (res?.status === 200) {
          setFUsername(res?.data[0].name);
          setFSupply(res?.data[0].total_supply);
          setFPrec(res?.data[0].decimals);
          setFSymbol(res?.data[0].symbol);
          setfPrice(res?.data[0].price);
          setContractAddr(res?.data[0].contract_address);
          setContractType(res?.data[0].contract_type);
          setCreatedAt(res?.data[0].createdAt);
          setStatus(res?.data[0].status);
        } else {
          setIsVisible(false);
        }
      });
    }
  }, [token]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setErrorMessage("");
      setSuccessMessage("");
      setSuccessMessageUpd("");
      setErrorMessageUpd("");
    }, 10000);

    return () => clearTimeout(timer);
  }, [errorMessage, successMessage, successMessageUpd, errorMessageUpd]);

  return (
    <>
      <Header {...props} />
      <div
        className="page-content"
        style={{ marginTop: "5rem", marginBottom: "5rem" }}
      >
        <div className="container">
          <div className="row offset-md-3">
            <div className="col-md-8">
              <div className="cstm_form">
                <div className="mb-4">
                  <div class="market-text">
                    <h3>Add Token</h3>
                  </div>
                </div>

                <div className="row">
                  <div className="col">
                    <label className="mt-2">Select Chain</label>
                    <select
                      class="form-select"
                      aria-label="Default select example"
                      value={chain}
                      onChange={(e) => setChain(e.target.value)}
                    >
                      <option selected>All</option>
                      <option value="erc20">Ethereum</option>
                      <option value="bep20">Binance</option>
                      <option value="polygon">Polygon</option>
                      <option value="trc20">Tron</option>
                      <option value="dtbx20">DTBX</option>
                    </select>{" "}
                  </div>
                </div>
                <br />

                <div className="form-group">
                  <div className="input-group">
                    <input
                      type="text"
                      className="form-control"
                      id="submit"
                      placeholder="Enter Token Address"
                      value={tokenAddr}
                      onChange={(e) => SetTokenAddr(e.target.value)}
                    />
                    <button
                      onClick={handleAddToken}
                      className="btn btn-primary"
                      type="button"
                      id="uploadBtn"
                    >
                      Fetch
                    </button>
                  </div>
                </div>
                <div className="my-3" style={{ minHeight: "24px" }}>
                  {errorMessage && (
                    <p className="text-danger mb-0 fs-14" id="msg">
                      {errorMessage}
                    </p>
                  )}
                  {successMessage && (
                    <p className="text-success mb-0 fs-14" id="msg">
                      {successMessage}
                    </p>
                  )}
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <label className="mt-2">Name</label>
                    <input
                      type="text"
                      className="form-control  "
                      required
                      id="name"
                      placeholder="Bitcoin"
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="mt-2">Symbol</label>
                    <input
                      type="text"
                      className="form-control  "
                      required
                      id="symbol"
                      placeholder="BTC"
                      value={symbol}
                      onChange={(e) => setSymbol(e.target.value)}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <label className="mt-2">Total Supply</label>
                    <input
                      type="number"
                      className="form-control  "
                      required
                      id="supply"
                      placeholder="1000000000000"
                      value={supply}
                      onChange={(e) => setSupply(e.target.value)}
                    />
                  </div>
                  <div className="col-md-6">
                    {" "}
                    <label className="mt-2">Precision</label>
                    <input
                      type="number"
                      className="form-control"
                      required
                      id="precision"
                      placeholder="10"
                      value={prec}
                      onChange={(e) => setPrec(e.target.value)}
                    />
                  </div>
                </div>

                <br />
                {isVisible && (
                  <>
                    <div className="row">
                      <div className="form-group col-md-6">
                        <label htmlFor="token">Token Image</label>
                        <input
                          className="form-control"
                          type="file"
                          onChange={(e) => {
                            uploadIMG(e);
                          }}
                        />
                      </div>
                      <div className="col-md-6">
                        <label>Price</label>
                        <input
                          type="number"
                          className="form-control"
                          required
                          id="price"
                          placeholder="$100"
                          value={price}
                          onChange={(e) => setPrice(e.target.value)}
                        />
                      </div>
                    </div>
                    <br />
                    <div className="text-center">
                      <button
                        className="btn btn-primary "
                        onClick={handleUpdateTkn}
                      >
                        Add Token
                      </button>
                    </div>

                    <div
                      className="my-3 text-center"
                      style={{ minHeight: "24px" }}
                    >
                      {errorMessageUpd && (
                        <p className="text-danger mb-0 fs-14" id="msg">
                          {errorMessageUpd}
                        </p>
                      )}
                      {successMessageUpd && (
                        <p className="text-success mb-0 fs-14" id="msg">
                          {successMessageUpd}
                        </p>
                      )}
                    </div>
                  </>
                )}
              </div>

              <div className="mb-4">
                <div class="market-text">
                  <h4>Token Details</h4>
                </div>
              </div>
              <div className="overflow-auto mt-5">
                <div className="table_scroll_div">
                  <table className="table global_table">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Symbol</th>
                        <th>Precision</th>
                        <th>Total Supply</th>
                        <th>Price</th>
                        <th>Contract Type</th>
                        <th>Contract Address</th>
                        <th>Created At</th>
                        <th>Status</th>
                      </tr>
                    </thead>

                    <tbody>
                      {/*============= Use this div when no data is found =============== */}
                      {fUsername && fSymbol ? (
                        <tr>
                          <td className="border-bottom-0 text-muted">
                            <p>{fUsername}</p>
                          </td>
                          <td className="border-bottom-0 text-muted">
                            <p>{fSymbol}</p>
                          </td>
                          <td className="border-bottom-0 text-muted">
                            <p>{fPrec}</p>
                          </td>
                          <td className="border-bottom-0 text-muted">
                            <p>{fSupply}</p>
                          </td>
                          <td className="border-bottom-0 text-muted">
                            <p>{fPrice}</p>
                          </td>
                          <td className="border-bottom-0 text-muted">
                            <p>{contractType}</p>
                          </td>
                          <td className="border-bottom-0 text-muted">
                            <p>{contractAddr}</p>
                          </td>
                          <td className="border-bottom-0 text-muted">
                            <p>{new Date(createdAt).toLocaleString()}</p>
                          </td>
                          <td className="border-bottom-0 text-muted">
                            <p>{status === 1 ? "Listed" : "Not Listed"}</p>
                          </td>
                        </tr>
                      ) : (
                        <tr>
                          <td
                            colSpan={9}
                            className="text-center border-bottom-0 text-muted"
                          >
                            <img
                              src="/img/no-data.png"
                              className="no-data-found"
                            />
                            <p>No records</p>
                          </td>
                        </tr>
                      )}

                      {/*============= Use this div when no data is found =============== */}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <br />
        </div>
      </div>

      <div className="spacer-sm"></div>

      <FooterNav />
      <Footer />
    </>
  );
}
